export default __webpack_public_path__ + "static/modal2-34ad2d46a42974d8510eef615530f882.png";